// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3C0tW","footer":"styles_footer__1UhhE","passCodeTooltip":"styles_passCodeTooltip__1RrTD"};